import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Check, X, ThumbsUp } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";
import {
  approveAdjustmentRequest,
  rejectAdjustmentRequest,
} from "@/Api/timeEntryAdjustmentRequests";
import { useToastNavigate } from "@/utils/toastNavigate";
import { LoaderSpin } from "@/components/Loaders";

export const DecideAdjustmentRequestBtns = ({
  uuid,
  onDecided,
}: {
  uuid: string;
  onDecided: () => void;
}) => {
  const { toast } = useToastNavigate();
  const [approving, setApproving] = useState(false);
  const [isRejectOpen, setIsRejectOpen] = useState(false);
  const [rejectNote, setRejectNote] = useState("");
  const [rejecting, setRejecting] = useState(false);

  const handleApprove = async () => {
    setApproving(true);
    const { data, ok } = await approveAdjustmentRequest(uuid);
    setApproving(false);
    if (!ok) {
      toast({
        description: data?.message || "Erro ao aprovar",
        variant: "destructive",
      });
      return;
    }
    toast({ description: "Solicitação aprovada!", action: <Check color="#1edc2b" /> });
    onDecided();
  };

  const handleReject = async () => {
    if (rejectNote.trim().length < 5) return;
    setRejecting(true);
    const { data, ok } = await rejectAdjustmentRequest(uuid, rejectNote);
    setRejecting(false);
    if (!ok) {
      toast({
        description: data?.message || "Erro ao rejeitar",
        variant: "destructive",
      });
      return;
    }
    setIsRejectOpen(false);
    setRejectNote("");
    toast({ description: "Solicitação rejeitada." });
    onDecided();
  };

  return (
    <div className="flex gap-2">
      <Button
        type="button"
        size="sm"
        className={cn(colors.bg_primary)}
        disabled={approving}
        onClick={handleApprove}
      >
        {approving ? <LoaderSpin /> : <ThumbsUp className="size-4" />}
        Aprovar
      </Button>

      <Dialog open={isRejectOpen} onOpenChange={setIsRejectOpen}>
        <DialogTrigger asChild>
          <Button type="button" size="sm" variant="destructive">
            <X className="size-4" />
            Rejeitar
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogDescription className="text-lg">
              Motivo da rejeição
            </DialogDescription>
          </DialogHeader>
          <Textarea
            value={rejectNote}
            onChange={(e) => setRejectNote(e.target.value)}
            placeholder="Explique por que a solicitação está sendo rejeitada (mín. 5 caracteres)"
          />
          <DialogFooter>
            <Button
              type="button"
              variant="destructive"
              className="w-full"
              disabled={rejecting || rejectNote.trim().length < 5}
              onClick={handleReject}
            >
              {rejecting ? <LoaderSpin /> : "Confirmar rejeição"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
